// Pure helpers over the Message shape. Kept as small named predicates so
// the call sites read like English ("isUserMessage", "isInProgress") rather
// than reaching into snake_case fields.

import type { Message } from '../types/thread';

export const isUserMessage = (m: Message): boolean => m.role === 'user';

export const isInProgress = (m: Message): boolean => m.in_progress === true;

/**
 * Id of the most recent user message, or `null` if the thread has none.
 * Drives the scroll-pin behaviour — each new user turn becomes the new
 * top-of-viewport anchor.
 */
export const getLastUserMessageId = (messages: Message[]): string | null => {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    if (isUserMessage(messages[i])) return messages[i].id;
  }
  return null;
};
